import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../../../Components/Cta";
import {
  RadioGroup,
  Input,
  CustomTextArea,
} from "../../../Components/FormElements";
import { CustomSelectBox } from "../../../Components/DropDown";
import { CustomPhoneInput } from "../../../Components/FormElements";
import { DatePickerSingle } from "../../../Components/Calender";

export default function Stage5({ setTitle, updateData, changePage }) {
  const [selectedOption, setSelectedOption] = useState("yes"); // Nominee yes/no
  const [addressSame, setAddressSame] = useState(false);

  // ✅ Nominee states
  const [nomineeName, setNomineeName] = useState("");
  const [nomineeRelation, setNomineeRelation] = useState("");
  const [startDate, setStartDate] = useState();
  const [allocation, setAllocation] = useState("");

  // ✅ Proof & Contact states
  const [idProof, setIdProof] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  // ✅ Address states
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [DateError, setDateError] = useState();

  // ✅ Error states
  const [nomineeNameError, setNomineeNameError] = useState("");
  const [nomineeRelationError, setNomineeRelationError] = useState("");
  const [allocationError, setAllocationError] = useState("");
  const [idProofError, setIdProofError] = useState("");
  const [idNumberError, setIdNumberError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");
  const [pincodeError, setPincodeError] = useState("");

  useEffect(() => {
    setTitle("Nominee details");
  },[setTitle]);

  const radioOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  const RELATION_OPTIONS = [
    { label: "Parent", value: "parent" },
    { label: "Child", value: "child" },
    { label: "Other", value: "other" },
  ];

  const ID_PROOF_OPTIONS = [
    { label: "Aadhaar", value: "aadhaar" },
    { label: "PAN", value: "pan" },
    { label: "Passport", value: "passport" },
  ];

  const COUNTRY_OPTIONS = [
    { label: "India", value: "india" },
    { label: "USA", value: "usa" },
  ];

  const STATE_OPTIONS = [
    { label: "Maharashtra", value: "maharashtra" },
    { label: "Karnataka", value: "karnataka" },
  ];

  const CITY_OPTIONS = [
    { label: "Mumbai", value: "mumbai" },
    { label: "Bangalore", value: "bangalore" },
  ];

  const handleRadioChange = (value) => setSelectedOption(value);

  // ✅ Validation
  const validateForm = () => {
    let valid = true;
    if (selectedOption === "yes") {
      // Nominee
      if (!nomineeName.trim()) {
        setNomineeNameError("Nominee name is required");
        valid = false;
      } else setNomineeNameError("");

      if (!nomineeRelation) {
        setNomineeRelationError("Please select a relation");
        valid = false;
      } else setNomineeRelationError("");

      if (!startDate) {
        setDateError("Select a date");
        valid = false;
      } else setDateError("");

      if (!allocation) {
        setAllocationError("Please enter allocation percentage");
        valid = false;
      } else if (isNaN(allocation) || allocation <= 0 || allocation > 100) {
        setAllocationError("Enter valid percentage (1–100)");
        valid = false;
      } else setAllocationError("");

      // Proof & Contact
      if (!idProof) {
        setIdProofError("Please select an ID proof");
        valid = false;
      } else setIdProofError("");

      if (!idNumber.trim()) {
        setIdNumberError("ID number is required");
        valid = false;
      } else setIdNumberError("");

      if (!phone.trim()) {
        setPhoneError("Phone number is required");
        valid = false;
      } else if (!phone.trim()) {
        setPhoneError("Enter valid 10-digit phone");
        valid = false;
      } else setPhoneError("");

      if (!email.trim()) {
        setEmailError("Email is required");
        valid = false;
      } else if (!/\S+@\S+\.\S+/.test(email)) {
        setEmailError("Enter valid email");
        valid = false;
      } else setEmailError("");

      // Address
      if (!address.trim()) {
        setAddressError("Address is required");
        valid = false;
      } else setAddressError("");

      if (!addressSame) {
        if (!country) {
          setCountryError("Select a country");
          valid = false;
        } else setCountryError("");

        if (!stateVal) {
          setStateError("Select a state");
          valid = false;
        } else setStateError("");

        if (!city) {
          setCityError("Select a city");
          valid = false;
        } else setCityError("");

        if (!pincode.trim()) {
          setPincodeError("Pincode is required");
          valid = false;
        } else if (!/^[0-9]{6}$/.test(pincode)) {
          setPincodeError("Enter valid 6-digit pincode");
          valid = false;
        } else setPincodeError("");
      }
    }

    return valid;
  };

  const _handleSubmit = () => {
    if (validateForm()) {
      const formData = {
        hasNominee: selectedOption,
        nomineeName: selectedOption === "yes" ? nomineeName : null,
        nomineeRelation: selectedOption === "yes" ? nomineeRelation : null,
        allocation: selectedOption === "yes" ? allocation : null,
        idProof,
        idNumber,
        phone,
        email,
        address,
        country,
        state: stateVal,
        city,
        pincode,
      };

      updateData((prev) => ({ ...prev, ...formData }));
      changePage(6);
    }
  };

  return (
    <div className="row row-gap-3">
      <div className="col-12 d-flex flex-column row-gap-3">
        {/* ✅ Nominee Section */}
        <div className="p-3 d-flex flex-column row-gap-3 mt-1 e-bg-ghost-white-dark e-border-radius-16 e-border-1px-pale-lavender">
          <div className="d-flex flex-column row-gap-2">
            <h5 className="e-primary-font-poppins e-font-weight-500 e-font-16">
              Do you want to add a nominee
            </h5>
            <p className=" e-font-16 e-font-weight-400 e-text-granite-gray m-0">
              Your portfolio passed to nominee if needed
            </p>
          </div>

          <RadioGroup
            type={2}
            require={true}
            data={radioOptions}
            selectedItem={selectedOption}
            onSelectItem={handleRadioChange}
          />

          {selectedOption === "yes" && (
            <>
              <Input
                require
                type="text"
                label="Nominee name"
                className="w-100"
                placeholder="Enter name"
                value={nomineeName}
                error={nomineeNameError}
                handleChange={setNomineeName}
                onBlur={validateForm}
              />

              <CustomSelectBox
                label="Nominee relation"
                placeholder="Select relation"
                require
                type={4}
                options={RELATION_OPTIONS}
                value={nomineeRelation}
                selectChange={setNomineeRelation}
                isSearchable={false}
                isClearable={false}
                error={nomineeRelationError}
              />
              <DatePickerSingle
                label="Date of Birth"
                require={true}
                labelStyle="e-font-16 e-font-weight-400 e-primary-font-poppins pb-2"
                startDate={startDate}
                onChange={setStartDate}
                placeholder="Select DOB"
                error={DateError}
              />
              <Input
                require
                label="Allocation Percentage"
                className="w-100"
                type="Number"
                placeholder="Add percentage"
                value={allocation}
                error={allocationError}
                handleChange={setAllocation}
                onBlur={validateForm}
              />
            </>
          )}
        </div>

        {/* ✅ Proof & Contact Section */}
        {selectedOption === "yes" && (
          <>
            <div className="p-3 d-flex flex-column row-gap-3 mt-1 e-bg-ghost-white-dark e-border-radius-16 e-border-1px-pale-lavender">
              <h5 className="e-primary-font-poppins e-font-weight-500 e-font-16">
                Proof & Contact
              </h5>

              <CustomSelectBox
                label="ID proof"
                placeholder="Select ID proof"
                require
                type={4}
                options={ID_PROOF_OPTIONS}
                value={idProof}
                selectChange={setIdProof}
                isSearchable={false}
                isClearable={false}
                error={idProofError}
              />

              <Input
                require
                type="text"
                label="Enter ID number"
                placeholder="Enter ID number"
                className="w-100"
                value={idNumber}
                error={idNumberError}
                handleChange={setIdNumber}
                onBlur={validateForm}
              />

              <CustomPhoneInput
                placeholder="Enter your phone number"
                label="Phone Number"
                require={true}
                value={phone}
                error={phoneError}
                handleChange={setPhone}
                onEnterKeyPress={_handleSubmit}
                onBlur={validateForm}
              />

              <Input
                require
                label="Email"
                className="w-100"
                placeholder="Enter email address"
                type="email"
                value={email}
                error={emailError}
                handleChange={setEmail}
                onBlur={validateForm}
              />
            </div>

            {/* ✅ Address Section */}
            <div className="p-3 d-flex flex-column row-gap-3 mt-1 e-bg-ghost-white-dark e-border-radius-16 e-border-1px-pale-lavender">
              <h5 className="e-primary-font-poppins e-font-weight-500 e-font-16">
                Address
              </h5>

              <CustomTextArea
                label="Address line 1"
                placeholder="Enter address"
                className="w-100"
                require={true}
                value={address}
                error={addressError}
                rows={3}
                handleChange={setAddress}
              />
              <div className="d-flex column-gap-2 align-items-center">
                <input
                  type="checkbox"
                  className="e-nominee-input"
                  checked={addressSame}
                  onChange={() => setAddressSame((prev) => !prev)}
                />
                <p className=" e-font-16 e-font-weight-400 e-text-granite-gray m-0">
                  Nominee has same address as yours
                </p>
              </div>
              {!addressSame && (
                <>
                  <div className="row row-cols-2">
                    <div className="col">
                      <CustomSelectBox
                        label="Country"
                        placeholder="Select country"
                        require
                        type={4}
                        options={COUNTRY_OPTIONS}
                        value={country}
                        selectChange={setCountry}
                        error={countryError}
                      />
                    </div>
                    <div className="col">
                      <CustomSelectBox
                        label="State"
                        placeholder="Select state"
                        require
                        type={4}
                        options={STATE_OPTIONS}
                        value={stateVal}
                        selectChange={setStateVal}
                        error={stateError}
                      />
                    </div>
                  </div>

                  <div className="row row-cols-2">
                    <div className="col">
                      <CustomSelectBox
                        label="City"
                        placeholder="Select city"
                        require
                        type={4}
                        options={CITY_OPTIONS}
                        value={city}
                        selectChange={setCity}
                        error={cityError}
                      />
                    </div>
                    <div className="col">
                      <Input
                        require
                        label="Pincode"
                        type="number"
                        className="w-100"
                        placeholder="Enter pincode"
                        value={pincode}
                        error={!!pincodeError}
                        errorMessage={pincodeError}
                        handleChange={setPincode}
                        onBlur={validateForm}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>

      {/* ✅ Footer */}
      <div className="col-lg-10 offset-lg-2 col-12">
        <div className="row">
          <div className="col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-border-1px-blue py-3 e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
              name="Go back"
              onPress={() => changePage(4)}
            />
          </div>
          <div className="col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-font-weight-500 py-3 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
              name="Continue"
              onPress={_handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
